module.exports = __webpack_public_path__ + "img/_footer_es.263f7537.png";